/**
 * Composable pour les permissions sur les quotes
 * Limite: 100 lignes max
 */

import { computed } from 'vue'
import { useAuth } from '../auth/useAuth.js'
import { hasAdminRights, isCommercial } from '../../constants/roles.js'

export function useQuotePermissions(quote) {
  const { user: currentUser } = useAuth()

  // L'assignation dit qui SUIT la demande, elle ne dit plus qui peut y toucher :
  // les commerciaux se remplacent pendant les congés et rattrapent les
  // assignations faites par erreur. Miroir de `canCommercialActOnQuote` côté
  // serveur ; c'est le serveur qui fait foi, l'écran ne fait que suivre.
  const peutAgir = computed(() => {
    if (!currentUser.value || !quote.value) return false
    return hasAdminRights(currentUser.value.role) || isCommercial(currentUser.value.role)
  })

  const canEdit = computed(() => {
    if (!peutAgir.value) return false
    const status = quote.value.status
    // Une demande signée, perdue ou encodée est figée pour tout le monde :
    // ce verrou-là n'a rien à voir avec l'assignation.
    const isFinalized = quote.value.signature_date ||
                       quote.value.signatureDate ||
                       status === 'devis_signe' ||
                       status === 'demande_perdue' ||
                       status === 'devis_perdu' ||
                       status === 'encode_digiforma'
    return !isFinalized
  })

  const canGenerateQuote = peutAgir

  const canChangeStatus = peutAgir

  return {
    canEdit,
    canGenerateQuote,
    canChangeStatus
  }
}
